module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks-device-filters"
  }, [(_vm.anyFilters) ? _c('div', {
    staticClass: "tasks-device-filters-reset-area"
  }, [_c('button', {
    staticClass: "tasks-device-filters-reset-all",
    on: {
      "click": _vm.clearAllFilters
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-filter fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "filter",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17\n              10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Reset filters")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-container",
    class: {
      'search-container': _vm.onlySearch
    }
  }, [_c('div', [(_vm.onlySearch) ? [_c('div', {
    staticClass: "tasks-device-filters-search",
    class: {
      'not-empty': _vm.titleSearchFilter[_vm.list] !== '', focused: _vm.titleSearchFilterFocused
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-search-input"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-search fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "search",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0\n                208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9\n                0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128\n                0 70.7-57.2 128-128 128z"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "id": 'titleSearchFilter-' + _vm.list,
      "type": "search",
      "aria-label": "Search task by ID or keyword",
      "placeholder": "Search task"
    },
    domProps: {
      "value": _vm.titleSearchFilter[_vm.list]
    },
    on: {
      "input": function($event) {
        return _vm.titleSearchInput($event)
      },
      "focus": function($event) {
        _vm.titleSearchFilterFocused = true
      },
      "blur": function($event) {
        _vm.titleSearchFilterFocused = false
      }
    }
  }), _vm._v(" "), (_vm.titleSearchFilter[_vm.list] !== '') ? _c('button', {
    staticClass: "tasks-device-filters-search-input-clear",
    on: {
      "click": function($event) {
        return _vm.clearFilter('title')
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                  0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                  12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                  0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.titleSearchFilter[_vm.list] !== ''),
      expression: "titleSearchFilter[list] !== ''"
    }],
    staticClass: "tasks-device-filters-search-results"
  }, [((_vm.list === 'backlog' && _vm.backlogTasks.length) || (_vm.list === 'focus' && _vm.focusTasks.length)) ? _vm._l(((_vm.list === 'backlog' ? _vm.backlogTasks : _vm.focusTasks)), function(task) {
    return _c('div', {
      staticClass: "tasks-device-filters-search-result",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goToTask(task.id)
        }
      }
    }, [_c('div', {
      staticClass: "tasks-device-filters-search-result-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(task.title, _vm.titleSearchFilter[_vm.list]))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tasks-device-filters-search-result-meta"
    }, [_c('div', [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-key",
      class: {
        'line-through': task.status === 4
      },
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(task.key, _vm.titleSearchFilter[_vm.list]))
      }
    }), _vm._v(" "), (task.chapter && _vm.getChapterById(task.chapter)) ? _c('div', {
      staticClass: "tasks-device-filters-search-result-meta-chapter"
    }, [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-chapter-progress"
    }, [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-chapter-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(_vm.getChapterById(task.chapter))
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + _vm.getChapterById(task.chapter)['id'],
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-user-info"
    }, [_c('div', {
      staticClass: "tasks-device-filters-search-result-meta-user status",
      class: ['status-' + task.status]
    }, [(task.status === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                              0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                              168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (task.status === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                              368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                              48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                              48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                              0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                              21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (task.status === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                              55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                              241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                              0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (task.status === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                              256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                              89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                              303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                              16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "tasks-device-filters-search-result-meta-user priority",
      class: ['priority-' + _vm.taskPriorityDelta(task.score)]
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-arrow-up fa-w-14",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "arrow-up",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6\n                        0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "tasks-device-filters-search-result-meta-user user-avatar"
    }, [(_vm.taskAssigneeById(task.assignee)) ? [(_vm.taskAssigneeById(task.assignee).image) ? _c('span', {
      style: ({
        backgroundImage: 'url(\'' + _vm.imageBase + _vm.taskAssigneeById(task.assignee).image + '\')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": _vm.taskAssigneeById(task.assignee).label,
        "size": 24,
        "color": "#ffffff"
      }
    })] : [_c('svg', {
      staticClass: "svg-inline--fa fa-user-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "user-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 496 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                              88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                              55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                              7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
      }
    })])]], 2)])])])])
  }) : _vm._e()], 2)] : [_c('div', {
    staticClass: "tasks-device-filters-chapter tasks-device-filters-area",
    class: {
      active: _vm.activeChapterFilter[_vm.list]
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-trigger",
    on: {
      "click": function($event) {
        return _vm.triggerFilter('chapter')
      }
    }
  }, [_vm._v("\n            Filter by Task category\n            "), (_vm.activeFiltersCount('chapter')) ? [_vm._v("\n              (" + _vm._s(_vm.activeFiltersCount('chapter')) + ")\n            ")] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-trigger-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-chapter-items tasks-device-filters-area-items",
    class: {
      empty: !_vm.filterApplied('chapter')
    }
  }, _vm._l((_vm.taskChapters), function(chapter) {
    return _c('div', {
      staticClass: "tasks-device-filters-chapter-item",
      class: {
        active: _vm.isFilterActive('chapter', chapter.id)
      },
      attrs: {
        "role": "button",
        "aria-label": 'Filter by: \'' + chapter.name + '\' chapter'
      }
    }, [_c('div', {
      staticClass: "tasks-device-filters-chapter-item-progress"
    }, [_c('div', {
      staticClass: "tasks-device-filters-chapter-item-image",
      style: ({
        backgroundImage: _vm.getChapterBackground(chapter)
      })
    }), _vm._v(" "), _c('svg', {
      staticClass: "progress",
      attrs: {
        "width": "130",
        "height": "130",
        "viewBox": "0 0 100 100"
      }
    }, [_c('circle', {
      staticClass: "progress_meter",
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }), _vm._v(" "), (_vm.getUserRole !== 'ta' && _vm.getUserRole !== 'tu') ? _c('circle', {
      staticClass: "progress_value",
      class: 'filters_progress_value-' + chapter.id,
      attrs: {
        "cx": "50",
        "cy": "50",
        "r": "44",
        "stroke-width": "5"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'chapterFilterInput-' + chapter.id
      },
      domProps: {
        "checked": _vm.isFilterActive('chapter', chapter.id)
      },
      on: {
        "click": function($event) {
          return _vm.filterByChapter(chapter)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "tasks-device-filters-chapter-item-label",
      attrs: {
        "for": 'chapterFilterInput-' + chapter.id
      }
    }, [_vm._v("\n                " + _vm._s(chapter.name) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "tasks-device-filters-area-item-clear",
      on: {
        "click": function($event) {
          return _vm.clearFilterItem('chapter', chapter.id)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), 0), _vm._v(" "), (_vm.activeFiltersCount('chapter')) ? _c('button', {
    staticClass: "tasks-device-filters-reset",
    on: {
      "click": function($event) {
        return _vm.clearFilter('chapter')
      }
    }
  }, [_vm._v("Clear filters")]) : _vm._e()]), _vm._v(" "), (_vm.list === 'backlog') ? _c('div', {
    staticClass: "tasks-device-filters-status tasks-device-filters-area",
    class: {
      active: _vm.activeStatusFilter[_vm.list]
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-trigger",
    on: {
      "click": function($event) {
        return _vm.triggerFilter('status')
      }
    }
  }, [_vm._v("\n            Filter by Status\n            "), (_vm.activeFiltersCount('status')) ? [_vm._v("\n              (" + _vm._s(_vm.activeFiltersCount('status')) + ")\n            ")] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-trigger-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-status-items tasks-device-filters-area-items",
    class: {
      empty: !_vm.filterApplied('status')
    }
  }, _vm._l((_vm.taskStatuses), function(status) {
    return _c('div', {
      staticClass: "tasks-device-filters-status-item-container",
      class: [{
        active: _vm.isFilterActive('status', status.id)
      }]
    }, [_c('div', {
      staticClass: "tasks-device-filters-status-item",
      class: [{
        active: _vm.isFilterActive('status', status.id)
      }, 'status-' + status.id]
    }, [(status.id === 1) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-dot-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "dot-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200\n                      0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0\n                      168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
      }
    })])] : (status.id === 2) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-spinner fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "spinner",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48\n                      368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49\n                      48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49\n                      48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156\n                      0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48\n                      21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
      }
    })])] : (status.id === 3) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-eye fa-w-18",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "eye",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4\n                      55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48\n                      241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0\n                      0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
      }
    })])] : (status.id === 4) ? [_c('svg', {
      staticClass: "svg-inline--fa fa-check-circle fa-w-16",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "far",
        "data-icon": "check-circle",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8\n                      256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532\n                      89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346\n                      303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068\n                      16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
      }
    })])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "status-text"
    }, [_vm._v("\n                  " + _vm._s(status.name) + "\n                ")])], 2), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'statusFilterInput-' + status.id
      },
      domProps: {
        "checked": _vm.isFilterActive('status', status.id)
      },
      on: {
        "click": function($event) {
          return _vm.filterByStatus(status)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'statusFilterInput-' + status.id,
        "aria-label": 'Filter by: \'' + status.name + '\' status'
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "tasks-device-filters-area-item-clear",
      on: {
        "click": function($event) {
          return _vm.clearFilterItem('status', status.id)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), 0), _vm._v(" "), (_vm.activeFiltersCount('status')) ? _c('button', {
    staticClass: "tasks-device-filters-reset",
    on: {
      "click": function($event) {
        return _vm.clearFilter('status')
      }
    }
  }, [_vm._v("Clear filters")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-assignee tasks-device-filters-area",
    class: {
      active: _vm.activeAssigneeFilter[_vm.list]
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-trigger",
    on: {
      "click": function($event) {
        return _vm.triggerFilter('assignee')
      }
    }
  }, [_vm._v("\n            Filter by Assignee\n            "), (_vm.activeFiltersCount('assignee')) ? [_vm._v("\n              (" + _vm._s(_vm.activeFiltersCount('assignee')) + ")\n            ")] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-trigger-arrow"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-chevron-down fa-w-14",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "chevron-down",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357\n                    24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569\n                    0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-assignee-items tasks-device-filters-area-items",
    class: {
      empty: !_vm.filterApplied('assignee')
    }
  }, [_vm._l((_vm.taskAssignee), function(user) {
    return _c('div', {
      staticClass: "tasks-device-filters-assignee-item",
      class: {
        active: _vm.isFilterActive('assignee', user.value)
      }
    }, [_c('div', {
      staticClass: "tasks-device-filters-assignee-item-icon"
    }, [(user.image) ? _c('span', {
      style: ({
        backgroundImage: 'url(\'' + _vm.imageBase + user.image + '\')'
      })
    }) : _c('avatar', {
      attrs: {
        "username": user.label,
        "size": 32,
        "color": "#ffffff"
      }
    })], 1), _vm._v(" "), _c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'assigneeFilterInput-' + user.value
      },
      domProps: {
        "checked": _vm.isFilterActive('assignee', user.value)
      },
      on: {
        "click": function($event) {
          return _vm.filterByAssignee(user)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'assigneeFilterInput-' + user.value
      }
    }, [_vm._v("\n                " + _vm._s(user.label) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "tasks-device-filters-area-item-clear",
      on: {
        "click": function($event) {
          return _vm.clearFilterItem('assignee', user.value)
        }
      }
    }, [_c('svg', {
      staticClass: "svg-inline--fa fa-times fa-w-11",
      attrs: {
        "aria-hidden": "true",
        "focusable": "false",
        "data-prefix": "fas",
        "data-icon": "times",
        "role": "img",
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 352 512"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "tasks-device-filters-assignee-item unassigned",
    class: {
      active: _vm.isFilterActive('assignee', 'unassigned')
    }
  }, [_c('div', {
    staticClass: "tasks-device-filters-assignee-item-icon"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-user-circle fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "user-circle",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 496 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0\n                88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4\n                55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1\n                7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    }
  })])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": 'assigneeFilterInput-unassigned'
    },
    domProps: {
      "checked": _vm.isFilterActive('assignee', 'unassigned')
    },
    on: {
      "click": function($event) {
        return _vm.filterByAssignee(false)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'assigneeFilterInput-unassigned'
    }
  }, [_vm._v("\n                Unassigned\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "tasks-device-filters-area-item-clear",
    on: {
      "click": function($event) {
        return _vm.clearFilterItem('assignee', 'unassigned')
      }
    }
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-times fa-w-11",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "times",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 352 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48\n                      0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28\n                      12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48\n                      0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    }
  })])])])], 2), _vm._v(" "), (_vm.activeFiltersCount('assignee')) ? _c('button', {
    staticClass: "tasks-device-filters-reset",
    on: {
      "click": function($event) {
        return _vm.clearFilter('assignee')
      }
    }
  }, [_vm._v("Clear filters")]) : _vm._e()])]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-302aa305","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tasks/includes/TasksDeviceFilters.vue
// module id = 908
// module chunks = 1